import {
  Co2MaterialAssignSettingsClient,
  Co2MaterialSettingType,
  GetCo2MaterialAssignSettingItemResponse,
  GetCo2MaterialAssignSettingResponse,
  UpdateCo2MaterialAssignSettingItemRequest,
  UpsertCo2MaterialSettingRequest,
} from "@api/apiClient";
import axios from "@api/axiosInstance";
import { queryClient } from "@hooks/useGlobalState";
import { useMutation, useQuery } from "@tanstack/react-query";

const co2MaterialAssignSettingsClient = new Co2MaterialAssignSettingsClient(undefined, axios);

export const useCo2MaterialAssignSettings = (mode: Co2MaterialSettingType, projectId: string | null | undefined, scenarioId?: string, profileId?: string | null, options?: any) => {
  return useQuery<GetCo2MaterialAssignSettingResponse>({
    ...options,
    queryKey: ["co2MaterialAssignSettings", mode, projectId, scenarioId, profileId],
    initialData: {},
    queryFn: async () => co2MaterialAssignSettingsClient.getCo2MaterialAssignSetting(mode, projectId, scenarioId, profileId),
  });
};

export const useUpsertCo2MaterialSettings = (options?: any) => {
  return useMutation<GetCo2MaterialAssignSettingResponse, unknown, UpsertCo2MaterialSettingRequest>({
    ...options,
    mutationFn: (upsertCo2MaterialSettingRequest: UpsertCo2MaterialSettingRequest) =>
      co2MaterialAssignSettingsClient.upsertCo2MaterialAssignSetting(upsertCo2MaterialSettingRequest),
  });
};

export const useUpdateCo2MaterialAssignSettingsItem = (options?: any) => {
  return useMutation<GetCo2MaterialAssignSettingItemResponse, unknown, UpdateCo2MaterialAssignSettingItemRequest>({
    ...options,
    mutationFn: (updateCo2MaterialAssignSettingItemRequest: UpdateCo2MaterialAssignSettingItemRequest) =>
      co2MaterialAssignSettingsClient.updateCo2MaterialAssignSettingItem(updateCo2MaterialAssignSettingItemRequest.co2MaterialAssignSettingId!, updateCo2MaterialAssignSettingItemRequest.co2MaterialAssignSettingItemId!, updateCo2MaterialAssignSettingItemRequest),
    onSuccess: async () => {
      await queryClient.resetQueries({ queryKey: ["co2MaterialAssignSettings"], exact: false });
      if (options?.onSuccess) {
        options.onSuccess();
      }
    },
  });
};


export const useCreateCo2MaterialAssignSettingsItem = (options?: any) => {
  return useMutation<GetCo2MaterialAssignSettingItemResponse, unknown, UpdateCo2MaterialAssignSettingItemRequest>({
    ...options,
    mutationFn: (updateCo2MaterialAssignSettingItemRequest: UpdateCo2MaterialAssignSettingItemRequest) =>
      co2MaterialAssignSettingsClient.createCo2MaterialAssignSettingItem(updateCo2MaterialAssignSettingItemRequest.co2MaterialAssignSettingId as string, updateCo2MaterialAssignSettingItemRequest),
    onSuccess: async () => {
      await queryClient.resetQueries({ queryKey: ["co2MaterialAssignSettings"], exact: false });
      if (options?.onSuccess) {
        options.onSuccess();
      }
    },
  });
};
